import React, { useEffect, useState } from "react";
import { ItemsSlider } from "./ItemsSlider";
import { ItemsSliderDesktop } from "./itemsSliderDesktop";
import Glide from "@glidejs/glide";

export const PlanesSlider = () => {
    const [vehiculos, setvehiculos] = useState([]);

    useEffect(() => {
        fetch("/modelos_planes_cuotas")
            .then(res => res.json())
            .then(result => {
                if (result.estado !== 0) {
                    setvehiculos(result);
                }
            });
    }, []);

    useEffect(() => {
        let slider = document.querySelector(".sliderPlanes");
        if (slider) {
            let glide = new Glide(".sliderPlanes", {
                gap: 0,
                animationDuration: 300,
                perView: 3,
                bound: true,
                breakpoints: {
                    600: {
                        perView: 1
                    },
                    992: {
                        perView: 2
                    }
                }
            });

            glide.mount();

            return () => glide.destroy();
        }
    }, [vehiculos]);

    return (
        <>
            <div className="sliderPlanesContainer my-base">
                <h1 className="title30black">PLANES</h1>
                {vehiculos.length != 0 ? (
                    <div className="glide sliderPlanes">
                        <div data-glide-el="track" className="glide__track">
                            <ul className="glide__slides sliderPlanes--ul">
                                {vehiculos.map(veh => veh.Planes[0].some(plan => plan.visible) ? (
                                    <ItemsSlider
                                        key={veh.id}
                                        link={"/planes/auto/" + veh.id}
                                        img={veh.hash_foto}
                                        name={veh.titulo}
                                        amount={veh.cuota_desde}
                                        id={veh.id}
                                    />
                                ) : <></>
                                )}
                            </ul>
                        </div>

                        <div
                            className="glide__arrows sliderPlanes--arrows"
                            data-glide-el="controls"
                        >
                            <button
                                className="glide__arrow glide__arrow--left"
                                data-glide-dir="<"
                            >
                                <img src="/images/icons/arrow-left.svg" />
                            </button>
                            <button
                                className="glide__arrow glide__arrow--right"
                                data-glide-dir=">"
                            >
                                <img src="/images/icons/arrow-right.svg" />
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="d-flex flex-column w-100 justify-content-center align-items-center">
                        <p className="mt-2">Actualizando Planes</p>
                        <div className="spinner-border text-bordo" role="status">
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
